import { create } from "zustand";

/** Volume and sound state. Not tied to Supabase profile; if profile fetch fails (e.g. 400), defaults (1.0) are used so audio still works. */
interface SoundStore {
  /** Game SFX/music enabled (Speaker icon) - default muted on fresh load */
  isSoundEnabled: boolean;
  /** Voice TTS enabled (Megaphone icon) - default off on fresh load */
  isVoiceEnabled: boolean;
  /** Game volume 0–1, applied when isSoundEnabled. Default 1.0. */
  gameVolume: number;
  /** Voice TTS volume 0–1. Default 1.0. */
  voiceVolume: number;
  toggleSound: () => void;
  toggleVoice: () => void;
  setVoiceEnabled: (enabled: boolean) => void;
  setSoundEnabled: (enabled: boolean) => void;
  setGameVolume: (v: number) => void;
  setVoiceVolume: (v: number) => void;
}

export const useSoundStore = create<SoundStore>((set) => ({
  isSoundEnabled: false,
  isVoiceEnabled: true,
  gameVolume: 0.5,
  voiceVolume: 0.5,
  toggleSound: () => set((s) => ({ isSoundEnabled: !s.isSoundEnabled })),
  toggleVoice: () => set((s) => ({ isVoiceEnabled: !s.isVoiceEnabled })),
  setVoiceEnabled: (enabled) => set({ isVoiceEnabled: enabled }),
  setSoundEnabled: (enabled) => set({ isSoundEnabled: enabled }),
  setGameVolume: (v) => set({ gameVolume: Math.max(0, Math.min(1, v)) }),
  setVoiceVolume: (v) => set({ voiceVolume: Math.max(0, Math.min(1, v)) }),
}));
